import React from "react";
import {
  ElementFactory,
  Question,
  Serializer,
  type SurveyModel,
} from "survey-core";
import { PropertyGridEditorCollection } from "survey-creator-core";
import {
  ReactQuestionFactory,
  SurveyQuestionElementBase,
} from "survey-react-ui";
import TemplateComponent from "shared/components/template/TemplateComponent";

export const CUSTOM_QUESTION_TYPE_RICH_TEXT_DISPLAY = "html";

// Create a question model for rich text display
export class QuestionRichTextDisplayModel extends Question {
  getType() {
    return CUSTOM_QUESTION_TYPE_RICH_TEXT_DISPLAY;
  }

  get hasInput() {
    return false;
  }

  get hideNumber() {
    return true;
  }

  set hideNumber(val: boolean) {
    // do nothing
  }

  get html() {
    return this.getPropertyValue("html");
  }
  set html(val) {
    this.setPropertyValue("html", val);
  }
}

// Create a class that renders rich text HTML content
export class SurveyQuestionRichTextDisplay extends SurveyQuestionElementBase {
  // SURVEYJS DOES NOT PROVIDE A TYPE FOR THIS CONSTURCTOR PROP AFAIK
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(props: any) {
    super(props);
  }

  get question() {
    return this.questionBase;
  }

  renderElement() {
    const { html } = this.question;

    if (!html) {
      return null;
    }

    let displayHtml = html;

    // Check if both the first and last characters are <p> and </p> respectively
    // Remove root paragraphs <p></p> if present
    if (
      displayHtml.charAt(0) === "<" &&
      displayHtml.charAt(1) === "p" &&
      displayHtml.charAt(2) === ">" &&
      displayHtml.charAt(displayHtml.length - 1) === ">" &&
      displayHtml.charAt(displayHtml.length - 2) === "/" &&
      displayHtml.charAt(displayHtml.length - 3) === "p"
    ) {
      displayHtml = displayHtml.substring(3);
      displayHtml = displayHtml.substring(0, displayHtml.length - 4);
    }

    //replace “ and ” with "
    // eslint-disable-next-line quotes
    displayHtml = displayHtml.replace(/“|”/g, '"');
    //replace ‘ and ’ with '
    displayHtml = displayHtml.replace(/‘|’/g, "'");

    const survey = this.question.getSurvey() as SurveyModel;
    const isCreator = survey?.getVariable("isCreator");
    // Apply survey-core's own root class for `html` questions so its
    // `.sd-html { white-space: initial }` rule cancels the `nowrap` inherited
    // from `.sd-row__question` (and so theme typography applies).
    const rootCssClass = this.question.cssClasses?.root;
    if (isCreator) {
      return (
        <div
          className={rootCssClass}
          dangerouslySetInnerHTML={{ __html: displayHtml }}
        ></div>
      );
    }
    return (
      <TemplateComponent
        className={rootCssClass}
        template={displayHtml}
        data={{ survey: this.question.getSurvey() }}
      />
    );
  }
}

export const RegisterRichTextDisplayComponent = () => {
  // Register the model in `ElementFactory` (will override native html type)
  ElementFactory.Instance.registerElement(
    CUSTOM_QUESTION_TYPE_RICH_TEXT_DISPLAY,
    (name) => {
      return new QuestionRichTextDisplayModel(name);
    },
  );

  // Add question type metadata for further serialization into JSON
  Serializer.addClass(
    CUSTOM_QUESTION_TYPE_RICH_TEXT_DISPLAY,
    [
      {
        name: "html",
        default: "",
        visible: true,
        category: "general",
      },
    ],
    function () {
      return new QuestionRichTextDisplayModel("");
    },
    "question",
  );

  // Register `SurveyQuestionRichTextDisplay` to override the native React renderer for `html` questions
  ReactQuestionFactory.Instance.registerQuestion(
    CUSTOM_QUESTION_TYPE_RICH_TEXT_DISPLAY,
    (name: string) => {
      return React.createElement(SurveyQuestionRichTextDisplay, name);
    },
  );

  // Register the CKEditor as the property editor for the html property in the Survey Creator's Property Grid
  PropertyGridEditorCollection.register({
    fit: function (prop) {
      return prop.name === "html";
    },
    getJSON: function () {
      return { type: "ckeditor" };
    },
  });
};
